import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import getQrcode, { clearTimer } from './getQrcode';

import { dateFormat, isEmpty } from 'utils/index';

import Header from 'components/Header';
import Loading from 'components/Loading';

import logo_unionpay from 'images/logo_unionpay.png';
const UseSucModal = React.lazy(() => import('components/UseSucModal'));

import styles from './index.less';
import { getShowTopBar } from '../../utils/getValue';

const tipsArr = [
  {
    before: '一、',
    value: '本权益涉及持卡人姓名、手机号、使用记录等信息的跨境传输，请您知悉。',
  },
  {
    before: '二、',
    value:
      '在使用本权益时，广州龙腾出行网络科技股份有限公司会为您生成16位龙腾卡号，该卡号会用于国际机场贵宾厅前场核销使用，请您知悉。',
  },
  {
    before: '1.',
    value:
      "This benefit involves the cross-border transmission of cardholder's name, mobile phone number, use record and other information. Please know.",
  },
  {
    before: '2.',
    value:
      'When using this equity, Guangzhou Longteng Travel Network Technology Co., Ltd. will generate a 16 digit Longteng card number for you, which will be used for front-end verification in the VIP Hall of the International Airport. Please know.',
  },
];

@connect(({ use, loading, home }) => ({
  data: home.data,
  qrcodeMsg: use.qrcodeMsg,
  loading: loading.effects['use/queryflushQrcode'],
}))
class Use extends Component {
  constructor(props) {
    super(props);
    this.state = {
      second: 60,
      tipLayer: false,
      record: {},
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { dragoncode, language } = this.props.location.query;
    const channel = this.props.location.query.channel;
    getQrcode(dispatch, { dragoncode, language });
  }

  onCancel() {
    window.history.go(-1);
  }

  componentWillUnmount() {
    clearTimer();
  }
  getNameStr(name) {
    return name.replace(/^./, '*');
  }
  render() {
    const { qrcodeMsg, loading } = this.props;
    const channel = this.props.location.query.channel;
    let dragoncode = qrcodeMsg && qrcodeMsg.dragoncode;
    dragoncode = dragoncode && dragoncode.replace(/\s/g, '').replace(/(.{4})/g, '$1 ');
    const showTopBar = getShowTopBar();
    let data = this.props.data;
    if (isEmpty(data)) {
      const storageData = localStorage.getItem('homeData') || '';
      data = storageData ? JSON.parse(storageData) : {};
    }
    const { name, card, enName } = data;
    const { pointNum, expiryDate } = card;
    const isOne = pointNum === 1;
    const useNumText = isOne ? '1' : '1~3';
    const tipText = isOne ? '持卡人本人尊享服务' : '您可携最多两位宾客共享服务，需与您乘坐同一航班';
    const tipTextEN = isOne
      ? 'Exclusive service for cardholder'
      : 'You can share the service with up to two guests on the same flight with you';

    return (
      <Fragment>
        <Header title={'订单详情'} />
        <Loading loading={loading}>
          <div
            className={styles.unionPayPage}
            style={{
              paddingTop: showTopBar ? '1.4rem' : '0.4rem',
            }}
          >
            <div className={styles.titleBox}>
              <img className={styles.logoUnionPay} src={logo_unionpay} />
              <div className={styles.infoBox}>
                <span className={styles.title}>国际机场贵宾厅</span>
                <span className={styles.titleEn}>International Airport VIP Lounge</span>
              </div>
            </div>
            <div className={styles.content}>
              <div className={styles.pointBox}>
                <span className={styles.pointTip}>{useNumText}人/次</span>
                <span className={styles.pointTipEn}>{useNumText} person/time</span>
              </div>
              <span className={styles.title}>刷码使用</span>
              <span className={styles.titleEn}>QR Code Access</span>
              <span className={styles.tip}>请将此页面展示给工作人员进行扫码</span>
              <span className={styles.tipEn}>
                please show this screen to lounge staff to access
              </span>
              <span className={styles.qrcodeText}>{dragoncode}</span>
              <img className={styles.qrCodeImg} src={qrcodeMsg.base64Data} alt="" />
              <div className={styles.userInfo}>
                <span>姓名: {this.getNameStr(name)}</span>
                {!!enName && <span>Name: {this.getNameStr(enName)}</span>}
                <span>有效期Valid: {dateFormat('YYYY-mm-dd', card.expiryDate)} 23:59:59</span>
              </div>
              <span className={styles.tip}>{tipText}</span>
              <span className={styles.tipEn}>{tipTextEN}</span>
            </div>
            {/* 温馨提示 */}
            <div className={styles.tipBox}>
              <span className={styles.title}>温馨提示 Tips</span>
              {tipsArr.map((el) => (
                <div className={styles.item}>
                  <span className={styles.before}>{el.before}</span>
                  <span className={styles.text}>{el.value}</span>
                </div>
              ))}
            </div>
          </div>
        </Loading>
        <React.Suspense fallback={'加载中...'}>
          <UseSucModal channel={channel} />
        </React.Suspense>
      </Fragment>
    );
  }
}

export default Use;
